import { createSelector } from 'reselect';

const selectReceipts = (state: any) => state.receipts;

export const selectReceiptsCurrentItem = createSelector([selectReceipts], (receipts) => receipts.current);

export const selectReceiptsListItems = createSelector([selectReceipts], (receipts) => receipts.list);

export const selectReceiptsItemById = (itemId: any) =>
    createSelector(selectReceiptsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectReceiptsQueryItems = createSelector([selectReceipts], (receipts) => receipts.query);

export const selectReceiptsCreatedItem = createSelector([selectReceipts], (receipts) => receipts.create);

export const selectReceiptsUpdatedItem = createSelector([selectReceipts], (receipts) => receipts.update);

export const selectReceiptsReadItem = createSelector([selectReceipts], (receipts) => receipts.read);

export const selectReceiptsDeletedItem = createSelector([selectReceipts], (receipts) => receipts.delete);

export const selectReceiptsSearchedItems = createSelector([selectReceipts], (receipts) => receipts.search);

export const selectReceiptsItemsCount = createSelector([selectReceipts], (receipts) => receipts.count);

export const selectReceiptsItemsFilter = createSelector([selectReceipts], (receipts) => receipts.filter);